class ProductSwatches extends HTMLElement {
  constructor() {
    super();
    this.titleToggle = this.querySelector('.product__swatches-title-toggle');
    this.swatches = this.querySelectorAll('.product__swatch');
    this.gridProductContainer = this.closest('.grid__item.grid-product');
    this.swatchesContainer = this.querySelector('.product__swatches-grid');
    this.isPageSwatch = this.getAttribute('data-is-product-page') === 'true';
    this.showMoreToggleTrigger = this.querySelector(
      '.product__swatches-grid-show-more-label',
    );
    this.productIds = [];
    this.initListeners();
  }

  initListeners = () => {
    this.swatches.forEach((swatchContainer) => {
      const id =
        Number(swatchContainer.getAttribute('data-product-id')) || null;
      if (this.titleToggle) {
        swatchContainer.addEventListener('mouseover', this.onMouseoverSwatch);
        swatchContainer.addEventListener('mouseout', this.onMouseoutSwatch);
      }
      if (this.gridProductContainer) {
        swatchContainer.addEventListener('click', this.onMouseClick);
      }
      if (id) {
        this.productIds.push(id);
      }
    });

    if (this.showMoreToggleTrigger) {
      this.showMoreToggleTrigger.addEventListener(
        'click',
        this.onToggleShowMore,
      );
    }

    if (!this.isPageSwatch) {
      return;
    }

    document.addEventListener(
      'swatches:checkAvailability',
      this.onProductVariantChange,
    );
  };

  onToggleShowMore = () =>
    this.swatchesContainer.classList.toggle('product__swatches-grid-reduced');

  onProductVariantChange = async (e) => {
    const targetId = e.detail?.product_id || null;
    const targetTitle = e.detail?.variant_title || null;
    if (!targetId) {
      return;
    }
    if (!targetTitle) {
      return;
    }
    if (this.productIds?.length === 0) {
      return;
    }
    if (this.productIds.includes(targetId)) {
      this.swatches.forEach(async (swatchContainer) => {
        const handle = swatchContainer.getAttribute('data-handle');
        if (!handle) {
          return;
        }
        const productData = await fetch(`/products/${handle}.js`).then((res) =>
          res.json(),
        );
        const targetVariant = productData.variants.find(
          (variant) => variant.title === targetTitle,
        );
        if (targetVariant && !targetVariant.available) {
          swatchContainer.classList.add('product__swatch-disabled');
        } else {
          swatchContainer.classList.remove('product__swatch-disabled');
        }
      });
    }
  };

  onMouseoverSwatch = (e) => {
    const el = e.currentTarget;
    if (!this.titleToggle) {
      return;
    }

    const titleSpan = this.titleToggle.querySelector('span');

    if (!titleSpan) {
      return;
    }

    titleSpan.innerHTML = el.getAttribute('data-title');
  };

  onMouseoutSwatch = () => {
    if (!this.titleToggle) {
      return;
    }

    const titleSpan = this.titleToggle.querySelector('span');

    if (!titleSpan) {
      return;
    }

    titleSpan.innerHTML = this.titleToggle.getAttribute('data-default-title');
  };

  onMouseClick = async (e) => {
    e.preventDefault();
    const el = e.currentTarget;
    const handle = el.getAttribute('data-handle');
    const id = el.getAttribute('data-product-id');
    if (!handle) {
      return;
    }
    const newProductContainer = await this.getProductContainer(handle);
    if (!newProductContainer) {
      return;
    }

    newProductContainer
      .querySelectorAll('image-element')
      .forEach((imageElement) => {
        imageElement.classList.add('aos-init', 'aos-animate');
      });
    newProductContainer
      .querySelectorAll('.quick-product__btn')
      .forEach((quickProductBtn) => {
        quickProductBtn.classList.remove('btn--not-ready');
      });
    this.gridProductContainer.innerHTML = newProductContainer.innerHTML;
    theme.preloadProductModal(
      handle,
      newProductContainer.getAttribute('data-product-id'),
      null,
    );
  };

  getProductContainer = async (handle) => {
    const perRow =
      Number(this.gridProductContainer.getAttribute('data-per-row')) || 3;
    const quickShop =
      this.gridProductContainer.getAttribute('data-quick-shop') === 'true';
    try {
      const rawHtml = await fetch(
        `/products/${handle}?view=swatch&per_row=${perRow}&quick_shop_enable=${quickShop}&end`,
      ).then((res) => res.text());
      return this.parseHTML(rawHtml);
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  parseHTML = (htmlString) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    return doc.body.firstChild;
  };
}

if (!customElements.get('product-swatches')) {
  customElements.define('product-swatches', ProductSwatches);
}
